import {BaseCard} from "../../Components/Cards/BaseCard";
import Logo from "../../Assets/images/logo/connectcaremintgreen.png";
import {IconInputCard} from "../../Components/Cards/IconInputCard";
import {
    faEnvelope,
    faFloppyDisk,
    faPencil,
    faTimes,
    faUser,
} from "@fortawesome/free-solid-svg-icons";
import {BlackButton} from "../../Components/Buttons/BlackButton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {LanguageSelector} from "../../Components/Form/LanguageSelector";
import {useBoundStore} from "../../Store/store";
import {useEffect, useState} from "react";
import {TextInput} from "../../Components/Form/TextInput";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {SecondaryButton} from "../../Components/Buttons/SecondaryButton";
import toast from "react-hot-toast";
import {useTranslation} from "react-i18next";
import {BranchesTable} from "../../Components/Tables/TableCards/BranchesTable";

export const MyProfile = () => {
    const {t} = useTranslation();
    const [isEditing, setIsEditing] = useState(false);

    const updateMe = useBoundStore(state => state.updateMe);
    const updateMyLocale = useBoundStore(state => state.updateMyLocale);
    const getMe = useBoundStore(state => state.getMe);
    const user = useBoundStore(state => state.user);

    const [forceRenewData, setForceRenewData] = useState(false);

    useEffect(() => {
        getMe();
    },[getMe]);


    const schema = yup.object({
        first_name: yup.string().required(),
        last_name: yup.string().required(),
    }).required()

    const {
        register,
        handleSubmit,
        formState: {errors},
        reset,
    } = useForm({
        resolver: yupResolver(schema),
        reValidateMode: 'onBlur',
        mode: 'onChange',
        defaultValues: {
            first_name: user?.firstname,
            last_name: user?.lastname,
            email: user?.email,
        }
    });

    useEffect(() => {
        if(user !== null){
            reset({
                first_name: user?.firstname,
                last_name: user?.lastname,
                email: user?.email,
            })
        }
    }, [user, isEditing]);

    const onSubmit = (data) => {
        updateMe(data);
        setIsEditing(!isEditing);
        toast.success(t('profile.toast_saved'))
    }

    return (
        <div>
            <div className={"rounded-lg mb-6 relative flex flex-row justify-between p-6"}>
                <div className={'opacity-40 rounded-lg bg-gradient-to-b from-primary to-secondary absolute top-0 left-0 w-full h-full'}></div>
                <div className={'z-10 my-auto'}>
                    <div className={"font-bold text-2xl p-2 flex flex-row"}>
                        <div className={'rounded-full w-12 h-12 p-2 bg-primary bg-opacity-60 mr-2 flex flex-col justify-center'}>
                            <span className={'m-auto text-md'}>👋</span>
                        </div>
                        <span className={'my-auto text-4xl'}>{t('profile.greeting', {name: user?.firstname})}</span>
                    </div>
                    <p>
                        {t('profile.welcome_message')}
                    </p>
                </div>

                <div className={'ml-4 z-10 max-h-52 hidden md:flex'}>
                    <img src={Logo} alt="logo" className={'w-full h-full object-contain'}/>
                </div>
            </div>

            <BaseCard>
                <form className={'grid grid-cols-1'} onSubmit={handleSubmit(onSubmit)}>
                    <div className={'grid grid-cols-1 md:grid-cols-2'}>
                        <h1 className={'text-xl font-bold mb-4'}>{t('profile.title')}</h1>
                        <div className={'flex flex-row justify-end'}>
                            {
                                !isEditing && (
                                    <BlackButton text={'secondary'} onClick={()=> setIsEditing(!isEditing)}>
                                        <FontAwesomeIcon icon={faPencil} className={'mr-2'}/> {t('general.actions.adjust')}
                                    </BlackButton>
                                )
                            }

                            {
                                isEditing && (
                                    <div className={'grid grid-cols-2 gap-4'}>
                                        <SecondaryButton text={'secondary'} onClick={()=> setIsEditing(!isEditing)}>
                                            <FontAwesomeIcon icon={faTimes} className={'mr-2'}/> {t('general.actions.cancel')}
                                        </SecondaryButton>
                                        <BlackButton outlined={true} type={'submit'}>
                                            <FontAwesomeIcon icon={faFloppyDisk} className={'mr-2'}/> {t('general.actions.save')}
                                        </BlackButton>
                                    </div>

                                )
                            }
                        </div>
                    </div>

                    <h2 className={'text-gray-500 text-sm'}>{t('register_page.section_personal_info')}</h2>
                    <div className={'grid grid-cols-1 md:grid-cols-2 gap-4 mt-2'}>
                        <IconInputCard
                            icon={faUser}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.first_name')}</p>
                            {
                                isEditing ? (
                                    <TextInput
                                        label={'first_name'}
                                        name={'first_name'}
                                        register={register}
                                        errors={errors}
                                    />
                                ) : (
                                    <p className={'text-xs'}>{user?.firstname}</p>
                                )
                            }
                        </IconInputCard>

                        <IconInputCard
                            icon={faUser}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.last_name')}</p>
                            {
                                isEditing ? (
                                    <TextInput
                                        label={'last_name'}
                                        name={'last_name'}
                                        register={register}
                                        errors={errors}
                                    />
                                ) : (
                                    <p className={'text-xs'}>{user?.lastname}</p>
                                )
                            }
                        </IconInputCard>
                    </div>

                    <div className={'grid grid-cols-1 gap-4 mt-2'}>
                        <IconInputCard
                            icon={faEnvelope}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.email')}</p>
                            <p className={'text-xs'}>{user?.email}</p>
                        </IconInputCard>
                    </div>
                </form>
            </BaseCard>

            {/* CCPSOM-30: language selector disabled until multi-language support is ready
            <BaseCard className={'mt-6'}>
                <h2 className={'text-gray-500 text-sm'}>{t('language.label')}</h2>
                <div className="mt-2 max-w-xs">
                    <LanguageSelector
                        value={user?.locale ?? 'nl'}
                        onChange={(loc) => updateMyLocale(loc)}
                    />
                </div>
            </BaseCard>
            */}

            <BaseCard className={'mt-6'}>
                <BranchesTable
                    userId={user?.id}
                    forceNewData={forceRenewData}
                    shouldUpdate={() => setForceRenewData(!forceRenewData)}
                    key={'branches-table'}
                />
            </BaseCard>
        </div>
    )
}